export default __webpack_public_path__ + "static/media/293.0e2a3d73.gif";